// НАЗВАНИЯ СТРАНИЦ. Используется в навигации и заголовках страниц.

const Auth = {
	Login: 'Вход',
	RecoveryStart: 'Восстановление пароля',
	RecoveryCheck: 'Ввод кода подтверждения',
	RecoverySet: 'Установка нового пароля',
	RecoveryFinish: 'Пароль установлен',
	// MainLanding: 'Лендинг',
	DeleteAccount: 'Удаление аккаунта',
	DeleteAccountConfirm: 'Подтверждение удаления аккаунта',
}

export const MainUrls = {
	Main: 'Главная',
	SchoolMain: 'Школа',
	Success: 'Успешна покупка',
	Fail: 'Покупка не удалась',
}

export const StudentUrls = {
	Students: 'Ученики',
	Student_Account: 'Профиль',
	Student_Orders: 'Заказы',
	Student_History: 'Журнал действий',
	Student_Visits: 'Посещения',
	Student_Visit: 'Курс',
}

export const StaffUrls = {
	Staff: 'Сотрудники',
	Employee: 'Сотрудники',
	Employee_Works: 'Группы сотрудника',
}

const Training = {
	Trainings: 'Мои курсы',
	Training: 'Курс',
	Training_Groups: 'Группы',
	Training_GroupConditions: 'Условия прохождения',
	Training_GroupCurators: 'Кураторы и менеджеры',
	Training_GroupOpenLessons: 'Открытые уроки',
	Lesson: 'Конструктор упражнения',
	Exercise: 'Прохождение упражнения',
}

const My = {
	MySchools: 'Мои школы',
	MySchool: 'Моя школа',
}

const LeadsUrls = {
	Leads: 'Лиды/покупки',
}

const Product = {
	Products: 'Лента ответов',
}

const Message = {
	Messages: 'Сообщения',
}

const Answer = {
	AnswersFeed: 'Лента ответов',
	AnswersFeedGroup: 'Лента ответов',
}

const Profile = {
	Profile: 'Профиль',
}

const Comment = {
	Comment: 'Комментарии',
}

const News = {
	News: 'Новости',
	NewsNew: 'Новая новость',
	NewsEdit: 'Редактирование новости',
}

const AudioCourse = {
	AudioCourse: 'Заговори на английском за 30 часов',
}

const urlRu = {
	auth: Auth,
	main: MainUrls,
	student: StudentUrls,
	staff: StaffUrls,
	training: Training,
	my: My,
	leads: LeadsUrls,
	product: Product,
	message: Message,
	answer: Answer,
	profile: Profile,
	audioCourse: AudioCourse,
	comment: Comment,
	news: News,
}

export default urlRu
